module.exports = __webpack_public_path__ + "static/media/h-slider-2.e4a8e8e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h-slider-2.jpg
// module id = 1145
// module chunks = 33